// extracted by mini-css-extract-plugin
export default {"listHeader":"FailedImage_listHeader__dvx3s","newLine":"FailedImage_newLine__c77ci"};